import { render, staticRenderFns } from "./EipI18nDialog.vue?vue&type=template&id=3fd4c86f&"
import script from "./EipI18nDialog.vue?vue&type=script&lang=js&"
export * from "./EipI18nDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports